import script from "./InventoryItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryItemList.vue?vue&type=script&setup=true&lang=js"

import "./InventoryItemList.vue?vue&type=style&index=0&id=07e5b32e&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e5b32e"]])

export default __exports__